import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

const popupRouteChildren: PermissionedRouteObject[] = [
  {
    index: true,
    lazy: async () => {
      const { PopupsPage } = await import("./popups-page");
      return { Component: PopupsPage };
    },
  },
  {
    path: "new",
    lazy: async () => {
      const { PopupTemplateSelection } =
        await import("./popup-template-selection");
      return { Component: PopupTemplateSelection };
    },
  },
  {
    path: "builder/:popupId",
    lazy: async () => {
      const { PopupBuilder } = await import("./popup-builder");
      return { Component: PopupBuilder };
    },
  },
];

const legacySpotlightRouteChildren: PermissionedRouteObject[] = [
  {
    index: true,
    lazy: async () => {
      const { PopupsPage } = await import("./popups-page");
      return { Component: PopupsPage };
    },
  },
  {
    path: "new",
    lazy: async () => {
      const { PopupTemplateSelection } =
        await import("./popup-template-selection");
      return { Component: PopupTemplateSelection };
    },
  },
  {
    path: "builder/:spotlightId",
    lazy: async () => {
      const { PopupBuilder } = await import("./popup-builder");
      return { Component: PopupBuilder };
    },
  },
];

export const popupRoutes: PermissionedRouteObject[] = [
  { handle: { breadcrumb: "Popups" }, children: popupRouteChildren },
];

/** @deprecated Use `/popups` routes; kept for bookmarked URLs. */
export const spotlightRoutes: PermissionedRouteObject[] = [
  { handle: { breadcrumb: "Popups" }, children: legacySpotlightRouteChildren },
];
